import { NAV_PATHS } from '@modules/common/constants';
import { OracleSearchActionType } from '@modules/oracle/store/oracleActionType';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { trackWisdomEvents } from '@modules/oracle/utils';
import { Button, ButtonProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';

interface CreateNewChatButtonProps {
  buttonText: string;
  buttonProps?: ButtonProps;
}

export const CreateNewChatButton = ({
  buttonText,
  buttonProps,
}: CreateNewChatButtonProps) => {
  const navigate = useNavigate();
  const { token: viewTokenFromURL } = useParseSavedSlugInfo();

  const dispatch = useOracleSearchStore(({ dispatch }) => dispatch);
  const initializeNewChat = () => {
    if (!viewTokenFromURL) {
      return;
    }

    dispatch({
      type: OracleSearchActionType.RESET,
    });

    try {
      trackWisdomEvents({
        eventName: 'Wisdom - Create New Chat',
      });
    } catch {}

    return navigate(`/${NAV_PATHS.WISDOM}`);
  };

  return (
    <Button {...buttonProps} onClick={initializeNewChat}>
      {buttonText}
    </Button>
  );
};
